/**
 *
 * Asynchronously loads the component for Inquiries
 *
 */
import Loadable from 'react-loadable';
import { DEFAULT_LOADABLE_DELAY, DEFAULT_LOADABLE_TIMEOUT } from 'shared/constants/App';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
  delay: DEFAULT_LOADABLE_DELAY,
  timeout: DEFAULT_LOADABLE_TIMEOUT,
});
